import React from 'react';
import Event from './Event.js';
import ModalForm from './Form/Form.js';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import ShareCheckboxes from './ShareCheckboxes';
import ApiRequest from "./ApiRequest";

export default class SingleShareModal extends ModalForm {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            form: {
                recipients: '',
                information: [],
                profiles: [],
                message: ''
            },
            errors: {},
            errorMessage: null,
            successMessage: null,
            loading: false,
            user: null
        };
    }

    componentDidMount() {
        if (this.props.show) {
            this.setState({show: true});
            this.sendAnalyticsPageView('singleshare');
        }

        Event.on('singleShareModal.show', (user) => {
            if (window.loggedInUser) {
                let form = this.state.form;
                form.profiles = [user.uid];
                this.setState({show: true, user, form, errors: {}, successMessage: null, errorMessage: null});
            } else {
                window.location.href = "/login";
            }
        }, this._rootNodeID);

        Event.on('modals.close', () => {
            this.setState({show: false});
        }, this._rootNodeID);
    }

    componentWillUnmount() {
        Event.off('singleShareModal.show', this._rootNodeID);
        Event.off('modals.close', this._rootNodeID);
    }

    share() {
        let form = this.state.form;
        form.sharedUrls = [{user: this.state.user.uid, url: this.previewUrl()}];

        this.setState({loading: true, successMessage: null, errorMessage: null, errors: {}}, () => {
            let request = new ApiRequest();
            request.post('profile/share', this.state.form, (err, res) => {
                if (res && res.body && res.body.success) {
                    let form = this.state.form;
                    form.message = '';
                    form.recipients = '';
                    this.setState({loading: false, form, successMessage: "The profile has been successfully shared."});
                } else {
                    if (res && res.body && res.body.hasOwnProperty('messages')) {
                        this.setState({loading: false, errors: res.body.messages});
                    } else {
                        if (res && res.body && !res.body.success && res.body.message) {
                            this.setState({loading: false, errorMessage: res.body.message});
                        }
                        this.setState({
                            errorMessage: "Something went wrong. Please try again.",
                            loading: false
                        });
                    }
                }
            });
        });
    }

    handleCheckboxChange(data) {
        let form = this.state.form;
        form.information = data;
        this.setState({form});
    }

    previewUrl() {
        let url = this.state.form.information.reduce((total, item) => {
            if (item.value) {
                total += `${item.name}=true&`;
            }
            return total;
        }, this.state.user && this.state.user.shareUrl ? this.state.user.shareUrl + '?share=true&' : '');
        return url.substring(0, url.length - 1);
    }

    validSenderFields() {
        let errors = this.state.errors;
        let invalidFields = ['firstname', 'lastname', 'email'].filter((fieldName) => {
            let invalid = !this.state.form[fieldName] || this.state.form[fieldName].length < 4;

            if (invalid) {
                errors[fieldName] = ['This field is required.'];
            } else {
                delete errors[fieldName];
            }

            return invalid;
        });

        if (invalidFields.length > 0) {
            this.setState({errors});
            return false;
        } else {
            return true;
        }
    }

    render() {
        return (
            <Modal isOpen={this.state.show} toggle={() => this.toggle()}>
                <ModalHeader toggle={() => this.toggle()}>
                    Share {this.state.user ? `${this.state.user.firstname} ${this.state.user.lastname}` : ''}'s Profile
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-12">
                        
                            {this.showSuccessMessage()}
                            {this.showErrorMessage()}

                            <div className={'form-group ' + this.getErrorClass('recipients')}>
                                <label>Recipients:</label>
                                <input value={this.state.form.recipients} onChange={(e) => this.handleChange('recipients', e.target.value)} type="text" className="form-control" placeholder="separate emails with comma"/>
                                {this.showError('recipients')}
                            </div>
                            <div className={'form-group ' + this.getErrorClass('message')}>
                                <label>Additional notes:</label>
                                <textarea onChange={(e) => this.handleChange('message', e.target.value)} className="form-control" value={this.state.form.message} rows="5" placeholder={this.state.user ? `Email content (your space to introduce ${this.state.user.firstname} to your contact)` : 'Email content (your space to introduce to your contact)'}></textarea>
                                {this.showError('message')}
                            </div>
                            <hr/>
                            <label>What information would you like to share about this applicant?</label>
                            <ShareCheckboxes onChange={(data) => this.handleCheckboxChange(data)} agentSite={this.state.user && this.state.user.siteUrl.indexOf('crew') === -1 && this.state.user.siteUrl.indexOf('stage') === -1}/>
                            <button type="button" onClick={() => this.share()} className="btn btn-primary btn-block mt-4">{this.state.loading ?
                                <i style={{
                                    width: '100%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    fontSize: '1rem'
                                }} className="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i> : 'Send'}</button>
                            <a href={this.previewUrl()} target="_blank">Preview Link</a>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        );
    }
}
